import React,{FC,useState,useEffect} from 'react'
import "./Sidebar.css"
import { signInWithPopup, signOut } from 'firebase/auth'
import { auth, provider } from './firebase'
import { useAuthState } from "react-firebase-hooks/auth"
import { useNavigate } from 'react-router-dom'

const Sidebar=() =>{
  const navigate = useNavigate();
  const signInWithGoogle =()=>{
    signInWithPopup(auth,provider).then((result)=>{
      setIsAuth(true)
    })
  }

  const signOutWithGoogle =()=>{
    signOut(auth).then(()=>{
    setIsAuth(false)});
  }

  const [user] =useAuthState(auth);
  const [isAuth,setIsAuth]=useState(false);
 
  return (
    <div className='sidebar'>
       
        {user ?(
          <>
           <h4>ようこそ</h4>
           <img src={auth.currentUser?.photoURL as string} alt=""/> 
           <button onClick={signOutWithGoogle} className='sidebar--tweet'>ログアウト</button>
          </>
        ):(
          <>
            <button  onClick={signInWithGoogle} className='sidebar--tweet'>ログイン</button>
            <h5>ログインして投稿しよう</h5>
          </>
          )}
        
    </div>
  )
}


export default Sidebar

